<template>
  <div class="icon-container" id="fly-cart-target" @click="onClick">
    <IconFont icon-name="gouwuche" class="icon-shopcart" />
    <van-dot
      type="num"
      :num="cartCountTrolley && cartCountTrolley.toString()"
      v-if="cartCountTrolley"
      :is-show="cartCountTrolley"
      dot-class="dot"
    ></van-dot>
  </div>
</template>

<script>
import IconFont from '@/components/iconFont.vue';

export default {
  components: { IconFont },
  props: {
    cartCountTrolley: {
      type: String | Number,
      default: null
    }
  },
  methods: {
    onClick() {
      this.$emit('onClick');
    }
  }
};
</script>

<style lang="less" scoped>
.icon-container {
  position: relative;
  .icon-shopcart {
    font-size: 24px;
    margin-left: 5.5px;
  }
  .dot {
    position: absolute;
    top: -4px;
    right: -6px;
  }
}

@keyframes mymove {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1.2);
  }
}
.moveToCart {
  animation: mymove 0.5s ease-in-out;
}
</style>